import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ChatLinksDataAnalytics } from '@main/online-chats/const';
import { CmsComponentData, LinkComponent } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SdCMSChatLinkComponent } from './chat-link.model';

@Component({
  selector: 'ui-chat-link',
  templateUrl: './chat-link.component.html',
  styleUrls: ['./chat-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatLinkComponent extends LinkComponent implements OnInit {
  data$: Observable<SdCMSChatLinkComponent>;
  dataAnalyticsAttribute$: Observable<string>;

  constructor(component: CmsComponentData<SdCMSChatLinkComponent>) {
    super(component);
  }

  ngOnInit(): void {
    this.dataAnalyticsAttribute$ = this.data$.pipe(
      filter(Boolean),
      map((componentData) => componentData.url),
      filter(Boolean),
      map((url) => {
        const matchingUrlValue = Object.values(ChatLinksDataAnalytics).find((x) => url.includes(x));

        return Object.keys(ChatLinksDataAnalytics)[Object.values(ChatLinksDataAnalytics).indexOf(matchingUrlValue)];
      }),
    );
  }
}
